import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './ui/estilos/index.css';

const raiz = document.getElementById('raiz');

if (!raiz) {
  throw new Error('Elemento raiz nao encontrado em index.html.');
}

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
